import Hero from './components/Hero';
import ServicesPreview from './components/ServicesPreview';
import WhyUs from './components/WhyUs';
import Reviews from './components/Reviews';
import LatestArticles from './components/LatestArticles';
import CTA from './components/CTA';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '凌晨不打烊',
  url: 'https://www.lingchenbudaye.com/',
  description: '凌晨不打烊是专业的24小时全天候服务平台，提供深夜下单、凌晨咨询、随时响应等不间断服务。无论几点都有人在线守候，用心陪伴每一位用户。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.lingchenbudaye.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '凌晨不打烊',
  url: 'https://www.lingchenbudaye.com/',
  description: '24小时全天候服务平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-0000',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
    hoursAvailable: {
      '@type': 'OpeningHoursSpecification',
      opens: '00:00',
      closes: '23:59',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    },
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <main>
        <Hero />
        <ServicesPreview />
        <WhyUs />
        <Reviews />
        <LatestArticles />
        <CTA />
      </main>
    </>
  );
}